import { Tile } from "./Tile";
export class TileGrid {
    constructor(width, height, layers = []) {
        const getTiles = layers.reduce((a, b) => (next) => a(b(next)), (x) => x)((x, y) => new Tile());
        this.tiles = [...Array(height)].map((_, y) => [...Array(width)].map((_, x) => getTiles(x, y)));
        this.tiles.forEach((row, y) => {
            row.forEach((tile, x) => {
                if (!tile)
                    return;
                if (y !== 0 && this.tiles[y - 1][x]) {
                    this.tiles[y - 1][x].link(1 /* bottom */, tile);
                }
                if (x !== 0 && row[x - 1]) {
                    row[x - 1].link(0 /* right */, tile);
                }
            });
        });
    }
    get(x, y) {
        return this.tiles[y][x];
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/TileGrid.ts
// module id = 14
// module chunks = 0